import React from 'react'
import CounsellorsSidebar from './CounsellorsSidebar'
import H2 from "@material-tailwind/react/Heading2";
import './CounsellorsCSS/upcomingSession.css'
import Button from "@material-tailwind/react/Button";

const UpcomingSession = () => {
    return (
        <div className="upcomingSession">
            <div className="counsNav">
                <CounsellorsSidebar/>
            </div> 
            <div className="upcomingSessionRight">
                <div className="reqSessionRightTop">
                    <div className="reqSessionRightLeft">
                        <H2 id='reqSessionRightLeftHead'>THANK YOU</H2>
                        <p>Medicines cure diseases but only doctors can cure patients. All doctors treat, but a good doctor lets nature heal.</p>
                    </div>
            
                    <div className="reqSessionRightRight">

                    </div>
                </div>

                <div className="reqSessionRightOptions">
                    <div className="req">
                        <h1 id='reqHeading'>John Dow</h1>
                        <div className="reqOptions">
                        
                            <div className="reqOptionsLeft">
                            
                                <h2>Date : 16/01/2001</h2>
                                <h2>Time : 12:00 AM</h2>
                                <h2>Duration : 02 Hours</h2>
                                <h2>Problem : Depression</h2>
                                <h2>Type : Video</h2>
                            </div>
                            <div className="reqOptionsRight">
                                <Button className='reqDivButtons' id='reqDivButtons1' ripple="light" >
                                    Accept
                                </Button> 
                                <Button className='reqDivButtons' id='reqDivButtons2' ripple="light" >
                                    reject
                                </Button> 
                                <Button className='reqDivButtons' id='reqDivButtons3' ripple="light" >
                                    Reschedule
                                </Button> 
                                <Button className='reqDivButtons' id='reqDivButtons4' ripple="light" >
                                    Abort
                                </Button> 
                            </div>
                        </div>
                    </div>

                    <div className="req">
                        <h1 id='reqHeading'>Cyrus Miley</h1>
                        <div className="reqOptions">
                        
                            <div className="reqOptionsLeft">
                            
                                <h2>Date : 16/01/2001</h2>
                                <h2>Time : 12:00 AM</h2>
                                <h2>Duration : 02 Hours</h2>
                                <h2>Problem : Depression</h2>
                                <h2>Type : Chat</h2>
                            </div>
                            <div className="reqOptionsRight">
                                <Button className='reqDivButtons' id='reqDivButtons1' ripple="light" >
                                    Accept
                                </Button> 
                                <Button className='reqDivButtons' id='reqDivButtons2' ripple="light" >
                                    reject
                                </Button> 
                                <Button className='reqDivButtons' id='reqDivButtons3' ripple="light" >
                                    Reschedule
                                </Button> 
                                <Button className='reqDivButtons' id='reqDivButtons4' ripple="light" >
                                    Abort
                                </Button> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpcomingSession
